import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import Loading from '../Common/Loading';

interface AdminRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ component: Component, ...rest }) => {
  const { admin, loading } = useAdminAuth();
  
  if (loading) {
    return <Loading />;
  }
  
  return (
    <Route
      {...rest}
      render={(props) =>
        admin ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/admin/login",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default AdminRoute;